// @flow
import WeekdayCalendar from './WeekdayCalendar';
export default WeekdayCalendar;
